import React from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'
import Dropdown, { ItemObject } from '../../../base/Dropdown/Dropdown'
import WidgetBody from '../../../base/Widget/WidgetBody'

export interface DropdownConfig {
  label: string
  className?: string
  required: boolean
}

export interface RecipientListProps {
  title: string
  detail?: string
  buttonContent?: string
  onSubmit?: () => void
  onClickBack?: () => void
  onClickCreate?: () => void
  dropdown: DropdownConfig
  recipients: ItemObject[]
  recipient: ItemObject
  form?: UseFormReturn
  isStart?: boolean
}

/**
 * @param {RecipientListProps} props
 * @param props.title (optional) - The title of the component
 * @param {UseFormReturn} props.form (Optional) - hook for managing forms with ease
 */
const RecipientList = (props: RecipientListProps) => {
  const useFormDefault = props.form || useForm()
  const {
    formState: { isSubmitting },
  } = useFormDefault

  Object.assign(RecipientList.defaultProps.dropdown, props.dropdown)
  Object.assign(RecipientList.defaultProps.recipient, props.recipient)
  if (props.recipients) RecipientList.defaultProps.recipients = props.recipients

  const onClickContinue = () => props.onSubmit?.()
  const onClickBack = () => props.onClickBack?.()
  const onClickCreate = () => props.onClickCreate?.()

  return (
    <WidgetBody
      title={props.title}
      subtitle='Choose who you would like to pay or add a new recipient yourself.'
      onBack={props.isStart ? undefined : onClickBack}
      otherActions={[{ label: 'add new', action: onClickCreate }]}
      onContinue={onClickContinue}
      isSubmitting={isSubmitting}
    >
      <Dropdown
        {...RecipientList.defaultProps.dropdown}
        form={useFormDefault}
        items={RecipientList.defaultProps.recipients}
        value={RecipientList.defaultProps.recipient?.value}
      />
    </WidgetBody>
  )
}

RecipientList.defaultProps = {
  title: 'Recipient',
  detail: 'Please select an existing recipient',
  buttonContent: 'Add Recipient',
  dropdown: {
    name: 'recipient',
    label: 'Select Recipient',
    required: true,
  },
  recipients: [
    { value: `123`, label: `joe's crab shack` },
    { value: '456', label: `danny's tree farm` },
  ],
  recipient: { value: '', label: '' },
  isStart: false,
}

export default RecipientList
